export default class CreateProjectFormulationProposalCtrl {

  constructor ($scope, $timeout, $mdDialog, $stateParams, WorkPlanSrv, WorkPlanModalSrv, $cookies, GlobalConfig, GlobalSrv) {
    var createProjectFormulationProposalVm = this
    const texts = GlobalConfig.appTexts

    createProjectFormulationProposalVm.currentUser = JSON.parse($cookies.get('currentUser'))

    let post = {
      teacherId: createProjectFormulationProposalVm.currentUser.teacherId,
      workplanId: createProjectFormulationProposalVm.currentUser.workplanId,
      name: createProjectFormulationProposalVm.currentUser.name
    }

    createProjectFormulationProposalVm.isEditing = Boolean($stateParams.workplanTeacherActivityId)
    createProjectFormulationProposalVm.typePeriod = []
    createProjectFormulationProposalVm.projectTypes = []
    createProjectFormulationProposalVm.financiers = []
    createProjectFormulationProposalVm.financiersArray = []
    createProjectFormulationProposalVm.hoursPlanned = null
    createProjectFormulationProposalVm.periodsArray = []
    createProjectFormulationProposalVm.isTouchedPeriods = false
    createProjectFormulationProposalVm.rangeType = GlobalConfig.periods.rangeType
    createProjectFormulationProposalVm.startDate = null
    createProjectFormulationProposalVm.endDate = null
    createProjectFormulationProposalVm.planningFinish = true
    createProjectFormulationProposalVm.minStartDate = moment().toDate()
    createProjectFormulationProposalVm.minEndDate = new Date()
    createProjectFormulationProposalVm.createOrEdit = 'Crear'
    createProjectFormulationProposalVm.potentialAllies = ''
    createProjectFormulationProposalVm.textCreateOrEdit = texts.saved
    createProjectFormulationProposalVm.isSaveButtonDisabled = false
    createProjectFormulationProposalVm.createOrEditMV = texts.createDialog
    createProjectFormulationProposalVm.isFeedback = createProjectFormulationProposalVm.currentUser.isFeedback
    createProjectFormulationProposalVm.dt_start = $cookies.get('wp_start')
    createProjectFormulationProposalVm.dt_end = $cookies.get('wp_end')


    createProjectFormulationProposalVm.funSelectedPeriod = funSelectedPeriod
    createProjectFormulationProposalVm.funSelectedFinancier = funSelectedFinancier
    createProjectFormulationProposalVm.hasError = hasError
    createProjectFormulationProposalVm.showErrorMessages = showErrorMessages
    createProjectFormulationProposalVm.addProjectFormulationProposal = addProjectFormulationProposal
    createProjectFormulationProposalVm.validateForm = validateForm
    createProjectFormulationProposalVm.validateCheklistPeriods = validateCheklistPeriods
    createProjectFormulationProposalVm.startDateChange = startDateChange
    createProjectFormulationProposalVm.cleanRangeType = cleanRangeType
    createProjectFormulationProposalVm.close = close

    createProjectFormulationProposalVm.updateRangeType = (val) => {
      createProjectFormulationProposalVm.rangeType = val
      createProjectFormulationProposalVm.periodsArray = []
      createProjectFormulationProposalVm.startDate = null
      createProjectFormulationProposalVm.endDate = null
    }
    createProjectFormulationProposalVm.updateRangeData = (val) => {
      createProjectFormulationProposalVm.periodsArray = val['periods']
      createProjectFormulationProposalVm.startDate = val['dates'][0]
      createProjectFormulationProposalVm.endDate = val['dates'][1]
    }

    activate()

    function activate () {
      if (createProjectFormulationProposalVm.isEditing) {
        createProjectFormulationProposalVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId
        createProjectFormulationProposalVm.createOrEdit = 'Editar'
        createProjectFormulationProposalVm.createOrEditMV = texts.editDialog
        createProjectFormulationProposalVm.textCreateOrEdit = texts.modified
        getDataProposal()
      }

      WorkPlanSrv.getListFormulatedExtensionProjects.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            loadData(dataReturn)
          } else {
            console.log('Comunications problem')
          }
        },
        data => {
          console.log()
        }
      )
    }

    function loadData (data) {
      createProjectFormulationProposalVm.typePeriod = data.listPeriods
      createProjectFormulationProposalVm.projectTypes = data.listFormulation.items
      createProjectFormulationProposalVm.financiers = data.listFinancial
    }

    function funSelectedPeriod (period, checked) {
      if (checked) {
        if (!createProjectFormulationProposalVm.periodsArray.includes(period.periodId)) {
          createProjectFormulationProposalVm.periodsArray.push(period.periodId)
        }
      } else {
        let index = createProjectFormulationProposalVm.periodsArray.indexOf(period.periodId)
        if (index !== -1) {
          createProjectFormulationProposalVm.periodsArray.splice(index, 1)
        }
      }
      createProjectFormulationProposalVm.isTouchedPeriods = true
    }

    function funSelectedFinancier (financier, checked) {
      if (checked) {
        if (!createProjectFormulationProposalVm.financiersArray.includes(financier.financialId)) {
          createProjectFormulationProposalVm.financiersArray.push(financier.financialId)
        }
      } else {
        let index = createProjectFormulationProposalVm.financiersArray.indexOf(financier.financialId)
        if (index !== -1) {
          createProjectFormulationProposalVm.financiersArray.splice(index, 1)
        }
      }
    }

    function startDateChange () {
      let m = moment(createProjectFormulationProposalVm.startDate)
      createProjectFormulationProposalVm.minEndDate = m.isValid() ? m/*.add(1, 'days')*/.toDate() : null
    }

    function hasError (input) {
      if (input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function showErrorMessages (input) {
      return input.$dirty || input.$touched
    }

    function validateForm (form) {
      return form.$invalid || createProjectFormulationProposalVm.validateCheklistPeriods()
    }

    function validateCheklistPeriods () {
      return (createProjectFormulationProposalVm.rangeType == 1 ? createProjectFormulationProposalVm.periodsArray.length < 1 : false)
    }

    function addProjectFormulationProposal (isExecution) {
      let origin = GlobalConfig.activityTypeId.originActivityPlanning
      if (isExecution) {
        origin = GlobalConfig.activityTypeId.originActivityExecution
      }
      createJson(origin)
    }

    function createJson (origin) {
      var proposal = {
        teacherId: post.teacherId,
        workplanId: post.workplanId,
        titleProject: createProjectFormulationProposalVm.title,
        summary: createProjectFormulationProposalVm.summary,
        observation: createProjectFormulationProposalVm.observation,
        potencialAllies: createProjectFormulationProposalVm.potentialAllies,
        hoursPlanning: createProjectFormulationProposalVm.hoursPlanned,
        idFormulation: createProjectFormulationProposalVm.projectType,
        activityId: GlobalConfig.minorActivityId.proposal,
        origin: origin,
        timeRangeTypeId: createProjectFormulationProposalVm.rangeType,
        isFeedbackActivity: createProjectFormulationProposalVm.isFeedback
      }

      if (createProjectFormulationProposalVm.isEditing) {
        proposal.workplanTeacherActivityId = createProjectFormulationProposalVm.workplanTeacherActivityId
      }

      if (parseInt(createProjectFormulationProposalVm.rangeType) === GlobalConfig.periods.rangeType) {
        var arrayPeriod = []
        for (var index in createProjectFormulationProposalVm.periodsArray) {
          var temp = {
            periodId: createProjectFormulationProposalVm.periodsArray[index]
          }
          arrayPeriod.push(temp)
        }
        proposal.periods = arrayPeriod
      } else {
        proposal.startDate = new Date(createProjectFormulationProposalVm.startDate)
        proposal.endDate = new Date(createProjectFormulationProposalVm.endDate)
      }

      // FINANCIERS
      var arrayFinancier = []
      for (var index in createProjectFormulationProposalVm.financiersArray) {
        var temp = {
          financialId: createProjectFormulationProposalVm.financiersArray[index]
        }
        arrayFinancier.push(temp)
      }
      proposal.financial = (arrayFinancier.length !== 0) ? arrayFinancier : null

      addOrEditFormulationProposal(proposal)
    }

    function addOrEditFormulationProposal (proposal) {
      createProjectFormulationProposalVm.isSaveButtonDisabled = true
      WorkPlanSrv.addProjectsExtensionFormulated.save(proposal).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          getSendNotify(proposal.origin)
          confirmAction()
        } else {
          createProjectFormulationProposalVm.isSaveButtonDisabled = false
        }
      }, function (data) {
        createProjectFormulationProposalVm.isSaveButtonDisabled = false
        console.log(data)
      })
    }

    function confirmAction () {
      let header = {
        createOrEdit: createProjectFormulationProposalVm.createOrEditMV,
        textCreateOrEdit: createProjectFormulationProposalVm.textCreateOrEdit,
        itemName: createProjectFormulationProposalVm.title,
        nameModal: texts.modalTypeName.projectFormulationExt,
        modalType: texts.modalTypeId.projectFormulationExt
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })
    }

    function getDataProposal () {
      let post = {
        workplanTeacherActivityId: parseInt(createProjectFormulationProposalVm.workplanTeacherActivityId)
      }
      WorkPlanSrv.getExtensionProjectsById.get(post).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          setValues(dataReturn.listExtension[0])
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {

      })
    }

    function setValues (proposal) {
      const dateValueSetter = (date) => moment(date, 'YYYY-MM-DD').isValid() ? moment(date, 'YYYY-MM-DD').toDate() : null
      createProjectFormulationProposalVm.title = proposal.titleProject
      createProjectFormulationProposalVm.summary = proposal.summary
      createProjectFormulationProposalVm.observation = proposal.observation
      createProjectFormulationProposalVm.potentialAllies = proposal.potencialAllies
      createProjectFormulationProposalVm.hoursPlanned = proposal.hoursPlanned
      createProjectFormulationProposalVm.projectType = proposal.idFormulation
      createProjectFormulationProposalVm.rangeType = proposal.timeRangeTypeId
      createProjectFormulationProposalVm.dt_start = dateValueSetter(proposal.startDate)
      createProjectFormulationProposalVm.dt_end = dateValueSetter(proposal.endDate)
      createProjectFormulationProposalVm.periodsArray = []
      createProjectFormulationProposalVm.selectedTypePeriod = {}
      createProjectFormulationProposalVm.financiersArray = []
      createProjectFormulationProposalVm.selectedFinancier = {}

      if (createProjectFormulationProposalVm.rangeType === GlobalConfig.periods.rangeType) {
        createProjectFormulationProposalVm.periodsArray = proposal.periodId.split(',').map(id => {
          createProjectFormulationProposalVm.selectedTypePeriod[Number(id)] = true
          return Number(id)
        })
      }
      // financiers
      if (proposal.idFinanciers) {
        createProjectFormulationProposalVm.financiersArray = proposal.idFinanciers.split(',').map(id => {
          createProjectFormulationProposalVm.selectedFinancier[Number(id)] = true
          return Number(id)
        })
      }

      if (proposal.startDate) {
        var startDateNew = moment(proposal.startDate, 'YYYY-MM-DD').toDate()
        if (startDateNew <= moment().toDate()) {
          createProjectFormulationProposalVm.minStartDate = moment(proposal.startDate, 'YYYY-MM-DD').toDate()
        }
        startDateChange()
      }

      createProjectFormulationProposalVm.isEditing = true
    }

    function cleanRangeType () {
      if (parseInt(createProjectFormulationProposalVm.rangeType) == GlobalConfig.periods.rangeType) {
        createProjectFormulationProposalVm.startDate = null
        createProjectFormulationProposalVm.endDate = null
      } else {
        createProjectFormulationProposalVm.periodsArray = []
        createProjectFormulationProposalVm.selectedTypePeriod = null
      }
    }

    function close () {
      return $mdDialog.hide()
    }

    function getSendNotify (origin) {
      let msg = 'El profesor ' + createProjectFormulationProposalVm.currentUser.dsFullname + ' ha registrado una nueva formulación de proyecto en la etapa de planeación.'
      if (origin == GlobalConfig.activityTypeId.originActivityExecution) {
        msg = 'El profesor ' + createProjectFormulationProposalVm.currentUser.dsFullname + ' ha registrado una nueva formulación de proyecto en la etapa de ejecución.'
      }
      let data = {
        idTeacher: post.teacherId,
        dsName: 'Notificación, se agregó o editó una formulación de proyecto',
        dsDescription: msg,
        idNotification_delivery_type: GlobalConfig.notificationType.inbox,
        is_grouped: 1,
        submodule: GlobalConfig.modules.extentionAndVisibility
      }
      GlobalSrv.sendNotificationsEvaluatorsSubmodule(data)
    }
  }// FIN DEL CONSTRUCTOR

  preventInput (event) {
    var vKey = 86
    if (event.keyCode == vKey) {
      event.preventDefault()
    }
    return
  }
}

CreateProjectFormulationProposalCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$stateParams', 'WorkPlanSrv', 'WorkPlanModalSrv', '$cookies', 'GlobalConfig', 'GlobalSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/extensionVisibility/projectFormulation/create/createProjectFormulationProposalCtrl.js